import localStorageKeys from "constants/localStorageKeys";
import { getItem, setItem } from "utils/localStorage";

import request from "./utils/request";

export function getCurrentSiteIdFromLocal(): string {
  return getItem(localStorageKeys.currentSiteId, "") as string;
}
export function setCurrentSiteIdToLocal(siteId: string) {
  setItem(localStorageKeys.currentSiteId, siteId);
}

export interface ISite {
  name: string;
  id: string;
  createdAt: string;
  updatedAt: string;
  isOwned?: boolean;
}

export interface ISites {
  own: ISite[];
  join: ISite[];
}

export function fetchSites(): Promise<ISites> {
  return request.get("/site");
}

export interface ISiteOverviewSummary {
  data: {
    today: number;
    total: number;
  };
  device: {
    online: number;
    total: number;
  };
  log: {
    today: number;
    total: number;
  };
}

export interface ISiteLocationInfo {
  center: GeoJSON.Point;
  border: GeoJSON.Polygon;
  province: string;
  city: string;
  area: string;
  detail: string;
}

export interface IDeviceLocationInfo {
  location: GeoJSON.Point;
  id: string;
  name: string;
  deviceType: {
    coverUrl: string;
  };
}
export interface ISiteLocationInfo {
  device: IDeviceLocationInfo[];
  site: ISiteLocationInfo;
}

export function fetchSiteLocation(siteId: string): Promise<ISiteLocationInfo> {
  return request.get(`/site/${siteId}/location`);
}

export interface ISiteLocation {
  // center: GeoJSONProps;
  // border: Polygon;
  center: any;
  border: any;
}

interface ISiteOverview {
  summary: ISiteOverviewSummary;
  location: ISiteLocation;
  id: string;
  name: string;
  updatedAt: string;
  createdAt: string;
}

export function fetchSiteOverview(siteId: string): Promise<ISiteOverview> {
  return request.get(`/site/${siteId}`);
}

export interface IStationInfo {
  name: string;
  id: string;
}

export interface ICreateStationDto {
  location: {
    center: GeoJSON.Point;
    text: string;
    border?: any;
  };
  name: string;
  remark?: string;
}

export function createStation(data: ICreateStationDto): Promise<IStationInfo> {
  return request.post(`/site`, JSON.parse(JSON.stringify(data)));
}
